import styles from './index.less';
import PcseoRecommondCard from '@jdh-cargo/block-pcseo-recommond-card';
import Affix from './affix';

export const parseUrl = (id: string, indexObj?: any) => {
  if (id.indexOf('all-all') > -1) {
    return {
      provinceId: undefined,
      cityId: undefined,
      departmentId: undefined,
      pageId: id.split('-')[indexObj?.pageId] || 1
    };
  }
  const { province, ...otherParams } = {
    province: id?.split('-')[indexObj?.position?.index],
    departmentId: (id.split('-')[indexObj?.departmentId] === 'all' ? undefined : id.split('-')[indexObj?.departmentId]) || undefined,
    pageId: id?.split('-')[indexObj?.pageId] || 1
  };
  return {
    provinceId: province !== 'all' ? province?.split('_')?.[indexObj.position.provinceId] || undefined : undefined,
    cityId: province !== 'all' ? province?.split('_')?.[indexObj.position.cityId] || undefined : undefined,
    ...otherParams
  };
};
export const Template = ({ children, isDetail = true }: any) => {
  return (
    <>
      <div className={styles.container}>
        <div className={styles.navs}>
          {/* 左侧悬浮 */}
          {!isDetail && <Affix />}
        </div>
        <div className={styles.left}>
          <div className={styles.content}>
            {/* 主要内容 */}
            {children}
          </div>
        </div>
        <div className={styles.right}>
          {/* 右侧 服务 */}
          <div className={styles.sticky}>
            <PcseoRecommondCard />
          </div>
        </div>
      </div>
      {/* // 底部线 */}
      <div className={styles.footerLine}>
        <p></p>
      </div>
      <div className={styles.footerData} id="m_common_bottom" />
    </>
  );
};
